import type { DateRange } from '@library/types/dates';
import type { DateTime } from 'luxon';
import { PrizepicksDateRange } from '@library/components/datePicker/PrizepicksDateRange';
import { useState } from 'react';

export interface PaymentsDateRangeProps {
  allowPastDates?: boolean;
  handleSelectDateRange: (dates: DateRange) => void;
  selectedEndDate: DateTime;
  selectedStartDate: DateTime;
}

export const PaymentsDateRange = ({
  allowPastDates = false,
  handleSelectDateRange,
  selectedStartDate,
  selectedEndDate
}: PaymentsDateRangeProps) => {
  const [endDatePickerOpen, setEndDatePickerOpen] = useState(false);
  const [startDatePickerOpen, setStartDatePickerOpen] = useState(false);

  return (
    <div
      className="inline-flex min-w-[400px] text-xs"
      data-testid="PaymentsDateRange"
    >
      <PrizepicksDateRange
        endDate={selectedEndDate.toJSDate()}
        endOpen={endDatePickerOpen}
        handleChange={handleSelectDateRange}
        minDate={!allowPastDates ? new Date() : undefined}
        startOpen={startDatePickerOpen}
        setEndOpen={setEndDatePickerOpen}
        setStartOpen={setStartDatePickerOpen}
        startDate={selectedStartDate.toJSDate()}
      />
    </div>
  );
};
